module.exports = __webpack_public_path__ + "img/danniel.6bfa0f79.png";